module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ARUx"
    }
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "pAL1p"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/loi#d4"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('h1', {
    staticClass: "h1a",
    staticStyle: {
      "margin-bottom": "4em"
    },
    attrs: {
      "id": "pArKN"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/loi#d4"
    }
  }, [_vm._v("Four Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pAhAN"
    }
  }, [_c('b', [_c('span', {
    staticClass: "dropcap",
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "AUxS"
    }
  }, [_vm._v("T")])]), _vm._v("he following vibrant stories illuminate how intergenerational experiences are\n\t\t\t\t\ttransforming churches as they engage teens and emerging adults, encourage young married\n\t\t\t\t\tcouples, support parents struggling to spiritually nurture their children, and foster\n\t\t\t\t\t"), _c('i', [_vm._v("attachment")]), _vm._v(" between older and younger congregants. ")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "pAKGI"
    }
  }, [_vm._v("\n\t\t\t\t\tWhen the Bulletin Becomes a Menu ")]), _vm._v(" "), _c('p', {
    staticClass: "centerv",
    attrs: {
      "id": "pAb_0"
    }
  }, [_vm._v("\n\t\t\t\t\tMelissa Cooper ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pA0Q4"
    }
  }, [_vm._v("\n\t\t\t\t\tA couple of years ago, I decided to spend Lent eating a vegetarian diet. For the\n\t\t\t\t\tfirst time in my life, entire menus weren’t available to me. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pAP7"
    }
  }, [_vm._v("\n\t\t\t\t\tEvery experience eating out became a scavenger hunt. At most restaurants, I had\n\t\t\t\t\ta maximum of one or two entrée options to choose from without requiring substitutions.\n\t\t\t\t\tI didn’t like always having to ask for things to be made slightly differently "), _c('i', [_vm._v("just")]), _vm._v("\n\t\t\t\t\tfor me. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pAgD3"
    }
  }, [_vm._v("\n\t\t\t\t\tI work in camp and retreat ministry serving hundreds of churches, so I visit churches\n\t\t\t\t\tabout as frequently as I visit restaurants. I’ve noticed that churches and restaurants\n\t\t\t\t\thave something in common. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pA3H43"
    }
  }, [_vm._v("\n\t\t\t\t\tA menu. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pAlvg"
    }
  }, [_vm._v("\n\t\t\t\t\tYou know—that piece of paper each person is handed as they enter worship. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz26-6"
    }
  }, [_vm._v("\n\t\t\t\t\tChurch menus come in all shapes and sizes—color or black and white, some with stock\n\t\t\t\t\timages of Jesus with children, or a chalice and bread on the front, some a single\n\t\t\t\t\tsheet, some a large, complicated booklet. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz26-7"
    }
  }, [_vm._v("\n\t\t\t\t\tThe intention of the bulletin is always to engage. Most immediately, the bulletin\n\t\t\t\t\tshares what you’ll be doing within the next hour. But there’s also always a page\n\t\t\t\t\tor more devoted to all the other activities happening throughout the week. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz26-8"
    }
  }, [_vm._v("\n\t\t\t\t\tThose are the pages intended to get you "), _c('i', [_vm._v("really")]), _vm._v(" engaged—not just for an hour, but\n\t\t\t\t\tultimately, over your lifetime. Those pages tell you how this church is the right\n\t\t\t\t\tplace for you: “Look at all these things we’ve got going on; and here are the ones\n\t\t\t\t\t"), _c('i', [_vm._v("just")]), _vm._v(" for you!” ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz26-9"
    }
  }, [_vm._v("\n\t\t\t\t\tMost church bulletins have become more complicated over time. In a world of consumeristic\n\t\t\t\t\tChristianity, where we have to compete with the yoga studio, coffee shop, or church\n\t\t\t\t\tdown the street, we feel like we have to show that “there’s something here "), _c('i', [_vm._v("just")]), _vm._v(" for\n\t\t\t\t\tyou!” ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz26-10"
    }
  }, [_vm._v("\n\t\t\t\t\tIn order to do that, we need page after page to show what classes are available after\n\t\t\t\t\tworship, and what groups meet throughout the week, and when there’s childcare and\n\t\t\t\t\twhen the youth group is going on a trip . . . and . . . and . . . and. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz26-11"
    }
  }, [_vm._v("\n\t\t\t\t\tWe have to be sure everyone finds something on our “menu” "), _c('i', [_vm._v("just")]), _vm._v(" for them. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz26-12"
    }
  }, [_vm._v("\n\t\t\t\t\tAnd we’ve taught them to expect this—we’ve told them we will be sure there is something\n\t\t\t\t\tfor everyone. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz26-13"
    }
  }, [_vm._v("\n\t\t\t\t\tAnd yet . . . what if you’re a vegetarian? What if you were not carefully considered\n\t\t\t\t\twhen the menu was created? ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz26-14"
    }
  }, [_vm._v("\n\t\t\t\t\tWhen I look at these bulletins—“church menus”—I seldom find anything I can eat.\n\t\t\t\t\tI’m not one of the desired consumers who was carefully considered as the menu was\n\t\t\t\t\tcrafted. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz26-15"
    }
  }, [_vm._v("\n\t\t\t\t\tI’m thirty-two years old. I’ve been married for eight years. I don’t have children,\n\t\t\t\t\tand I don’t plan to. I very seldom find anything “"), _c('i', [_vm._v("just")]), _vm._v(" for me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz26-16"
    }
  }, [_vm._v("\n\t\t\t\t\tAnd even when I do, as a millennial, I’ve been catered to my whole life through media\n\t\t\t\t\tand community events—so I know what’s going on. I know pandering when I see it. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz27-6"
    }
  }, [_vm._v("\n\t\t\t\t\tBut you know the churches I find most inviting—the ones that I feel like I could\n\t\t\t\t\tfit in the most with? It’s the little country churches—small and vibrant and vital.\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz27-7"
    }
  }, [_vm._v("\n\t\t\t\t\tI don’t wonder if they have something just for me; I don’t have to search a long\n\t\t\t\t\tlist of activities and classes to see if I’ve been considered. They know they can’t\n\t\t\t\t\thave a menu long enough to meet everyone’s needs, so they don’t try. The few activities\n\t\t\t\t\tthey do offer are open to "), _c('i', [_vm._v("everyone.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz27-8"
    }
  }, [_vm._v("\n\t\t\t\t\tSo I wonder . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz27-9"
    }
  }, [_vm._v("\n\t\t\t\t\tHow do we stop treating the bulletin like a menu? ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz27-10"
    }
  }, [_vm._v("\n\t\t\t\t\tHow can we stop exhausting ourselves trying to meet the needs of each individual\n\t\t\t\t\twho walks through our doors? How can we make it clear that this church is for everyone,\n\t\t\t\t\twithout having to name every group it includes? ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz27-11"
    }
  }, [_vm._v("\n\t\t\t\t\tWhat if we didn’t have to treat our bulletins and calendars like menus? What if we\n\t\t\t\t\tinstead sought ways to bring people together around commonalities other than age\n\t\t\t\t\tor stage in life? ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz27-14"
    }
  }, [_vm._v("\n\t\t\t\t\tBeing intergenerational does not mean we add more items to our church calendar; it\n\t\t\t\t\tdoesn’t mean we add an intergenerational “program” to an already long list of groups\n\t\t\t\t\tand classes and activities. Instead, what if the majority of our existing programs\n\t\t\t\t\twere meant for everyone? ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz27-18"
    }
  }, [_vm._v("\n\t\t\t\t\tWe may still have a specialty offering here and there; but if we can make the core\n\t\t\t\t\tof our church’s life something that includes all and welcomes all, regardless of\n\t\t\t\t\tage or stage, then no one has to go searching for what they’re allowed to attend,\n\t\t\t\t\tand no one has to ask for substitutions. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz27-19"
    }
  }, [_vm._v("\n\t\t\t\t\tSo I challenge you: As we vision and dream for the future of our churches, let’s\n\t\t\t\t\tstop treating the bulletin like a menu that offers “something for everyone,” along\n\t\t\t\t\tthe way leaving someone out. Let’s create documents that serve as invitations to\n\t\t\t\t\tparticipate in a vibrant, vital community. How about we make most of our “somethings”\n\t\t\t\t\tactually for "), _c('i', [_vm._v("everyone")]), _vm._v("? ")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "pz27-20"
    }
  }, [_vm._v("\n\t\t\t\t\tParents as Partners ")]), _vm._v(" "), _c('p', {
    staticClass: "centerv",
    attrs: {
      "id": "pz27-21"
    }
  }, [_vm._v("\n\t\t\t\t\tAmy Kippen ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz27-22"
    }
  }, [_vm._v("\n\t\t\t\t\t“What is the matter with parents these days?” “Why are parents not involved?” “Are\n\t\t\t\t\tfamilies too busy for church?” ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz28-6"
    }
  }, [_vm._v("\n\t\t\t\t\tThese were common questions at my congregation, mostly asked behind closed doors;\n\t\t\t\t\tquestions that smacked of judgment; questions that produced not a solution, but increasing\n\t\t\t\t\tresentment toward parents. At the same time, more and more of our youth were “graduating”\n\t\t\t\t\tfrom church in their teen years. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz28-7"
    }
  }, [_vm._v("\n\t\t\t\t\tOur faith formation approaches at the time were not accomplishing the goal of creating\n\t\t\t\t\tlifelong followers of Jesus who value Christian community. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz28-8"
    }
  }, [_vm._v("\n\t\t\t\t\tAnd asking these questions produced more questions. Why are parents intensely involved\n\t\t\t\t\tin their kids’ activities, but not committing to church involvement? Why does the\n\t\t\t\t\thockey or dance coach get parents’ commitment? ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz28-9"
    }
  }, [_vm._v("\n\t\t\t\t\tThe answers were hard to acknowledge, and the truth was hard to face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Parents are\n\t\t\t\t\tthe primary teachers of faith whether they know and acknowledge it or not. Parents\n\t\t\t\t\tare indeed busy; however, they are constantly making choices about their time. Those\n\t\t\t\t\tcoaches we resent actually expect parents to be involved; if you are going to be\n\t\t\t\t\ta dance parent, you must work the fundraiser. It comes with signing up. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz28-10"
    }
  }, [_vm._v("\n\t\t\t\t\tAlong the way, our age-specific church programs have inadvertently become just one\n\t\t\t\t\tmore thing on the family’s weekly schedule, no different than piano lessons or soccer\n\t\t\t\t\tpractice. Yet even when parents meet our expectation that they bring their children\n\t\t\t\t\tto church, many children are not becoming lifelong followers of Jesus who value Christian\n\t\t\t\t\tcommunity. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz28-11"
    }
  }, [_vm._v("\n\t\t\t\t\tAcknowledging these truths meant making a significant change in the way we cultivate\n\t\t\t\t\tfaith formation in our church, and we needed to find a way to get families to practice\n\t\t\t\t\tfaith at home too. We needed to raise the expectation of parents both at church and\n\t\t\t\t\tat home—and ordering a new curriculum wouldn’t suffice. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz28-12"
    }
  }, [_vm._v("\n\t\t\t\t\tWe needed to change the entire system. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz28-13"
    }
  }, [_vm._v("\n\t\t\t\t\tSo, just short of twenty years ago, we stopped doing Sunday school and started a\n\t\t\t\t\tweekly family program. No longer could parents drop their children off at church.\n\t\t\t\t\tFaith formation was now something families did together. There were no Sunday school\n\t\t\t\t\tclasses and no teachers. We had intentionally become the church with no class. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz29-6"
    }
  }, [_vm._v("\n\t\t\t\t\tWas this change easy? No. Were some parents upset? Yes. Were we confident that God\n\t\t\t\t\twas calling us to make this change? Yes. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz29-7"
    }
  }, [_vm._v("\n\t\t\t\t\tSo, in the midst of our fear, we stood on the knowledge that God had called "), _c('i', [_vm._v("us")]), _vm._v(" to\n\t\t\t\t\tbe brave, visionary leaders. And if the leaders of our church didn’t lead the church\n\t\t\t\t\tinto a new future, who would? ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz29-8"
    }
  }, [_vm._v("\n\t\t\t\t\tWe called our weekly family gathering "), _c('i', [_vm._v("GIFT")]), _vm._v("—Generations in Faith Together. GIFT is\n\t\t\t\t\ta lively mix of Sunday school, VBS, family Bible camp, and worship. All ages and\n\t\t\t\t\tstages learn together, creating lasting intergenerational connections. To help alleviate\n\t\t\t\t\tparents’ fears, we said again and again, “Just know that you don’t need to know anything\n\t\t\t\t\tyou don’t already know or be anyone you’re not. Just come.” ")]), _vm._v(" "), _c('p', {
    staticClass: "indentv",
    attrs: {
      "id": "pz29-9"
    }
  }, [_vm._v("\n\t\t\t\t\tAnd from the beginning, we communicated our mission through this motto: ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz29-10"
    }
  }, [_c('i', [_vm._v("Bless the child")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz29-11"
    }
  }, [_c('i', [_vm._v("Gift the family")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz29-12"
    }
  }, [_c('i', [_vm._v("Every week at church")])]), _vm._v(" "), _c('p', {
    staticClass: "indentv",
    attrs: {
      "id": "pz29-13"
    }
  }, [_c('i', [_vm._v("Every night in every home")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz29-14"
    }
  }, [_vm._v("\n\t\t\t\t\tThese four simple lines convey that GIFT is for the child and the family and set\n\t\t\t\t\tthe expectation that faith formation happens both at church and at home. This motto\n\t\t\t\t\tserves to outline a "), _c('i', [_vm._v("partnership")]), _vm._v(" between parents and church, and, as in any healthy\n\t\t\t\t\tpartnership, there are agreed-upon roles and responsibilities. ")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "pz29-15"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "AvCA"
    }
  }, [_vm._v("Every Week at Church")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz29-16"
    }
  }, [_vm._v("\n\t\t\t\t\tThe "), _c('i', [_vm._v("church’s role")]), _vm._v(" is to make GIFT engaging for people of all ages—a weekly highlight\n\t\t\t\t\tfor all. We commit to modeling the love of Jesus and helping everyone know and experience\n\t\t\t\t\tGod’s love. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz29-17"
    }
  }, [_vm._v("\n\t\t\t\t\tThe "), _c('i', [_vm._v("parents’ role")]), _vm._v(" is to make attendance a priority, to decide up front that “we are\n\t\t\t\t\ta family that goes to church unless we are sick or out of town.” Additionally, we\n\t\t\t\t\task parents to be engaged with GIFT—to fully participate with positivity. ")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "pz29-18"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "Az1Y"
    }
  }, [_vm._v("Every Night in Every Home")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "AMNR"
    }
  }, [_vm._v("\n\t\t\t\t\tWe challenge "), _c('i', [_vm._v("parents")]), _vm._v(" to practice faith through a simple, nightly, five-step faith\n\t\t\t\t\tritual called "), _c('i', [_vm._v("FAITH5")]), _vm._v(". Families get together each night for a Home "), _c('span', {
    attrs: {
      "id": "z30-6"
    }
  }, [_vm._v("Huddle to check\n\t\t\t\t\tin, read Scripture, talk, pray, and bless one another before turning out the lights\n\t\t\t\t\ton the day. This nightly ritual sets a family on the firm foundation of shared faith\n\t\t\t\t\tenabling them to grow together spiritually."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a1",
      "id": "d1"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz30-7"
    }
  }, [_vm._v("\n\t\t\t\t\tIn a recent poignant conversation, a GIFT dad shared, ")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "pz30-8"
    }
  }, [_vm._v("\n\t\t\t\t\t\tI didn’t want to come to GIFT with my family, and I certainly didn’t want to do that\n\t\t\t\t\t\tFAITH5 thing every night. You know, I’m not really a churchy person. But last week,\n\t\t\t\t\t\twhen Cali [five years old] led our FAITH5 prayer, it struck me—faith is not just\n\t\t\t\t\t\tsomething we do; this is who we are. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz30-9"
    }
  }, [_vm._v("\n\t\t\t\t\tMoving our understanding of church from drop-off culture to partnership, and seeing\n\t\t\t\t\tparents as the main faith mentors and the church as an ally, is who we have become.\n\t\t\t\t\t")]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "pz30-10"
    }
  }, [_vm._v("\n\t\t\t\t\tFriday Night Live ")]), _vm._v(" "), _c('p', {
    staticClass: "centerv",
    attrs: {
      "id": "pz30-11"
    }
  }, [_vm._v("\n\t\t\t\t\tAqueelah Ligonde ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz30-12"
    }
  }, [_vm._v("\n\t\t\t\t\tWhen I was in my twenties, if you had asked me how I imagined my Friday nights ten\n\t\t\t\t\tyears into the future, I would have described a fabulous scene where I would be dancing\n\t\t\t\t\tand laughing with friends at fancy lounges. I would "), _c('i', [_vm._v("not")]), _vm._v(" have said, “At church, with\n\t\t\t\t\ta bunch of children and teens eating, playing, praying, and learning.” ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz30-13"
    }
  }, [_vm._v("\n\t\t\t\t\tBut as it turned out, that’s exactly where I found myself in my thirties. Eating,\n\t\t\t\t\tplaying, praying, learning, and laughing with a bunch of children and teens and Jesus-loving\n\t\t\t\t\tadults. Every Friday night, I found myself conversing around the table, sitting\n\t\t\t\t\ton the floor, creating with crayons, or eating cupcakes. Every Friday night was fabulously\n\t\t\t\t\talive . . . and I wouldn’t change it for the world. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz30-14"
    }
  }, [_vm._v("\n\t\t\t\t\tFirst Presbyterian Church in Jamaica (known as First Jamaica) is located in the heart\n\t\t\t\t\tof Jamaica, Queens, New York. First Jamaica has existed for 350 years and has a strong\n\t\t\t\t\thistory of serving and loving on the incredible community that surrounds it. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz30-15"
    }
  }, [_vm._v("\n\t\t\t\t\tIn 2010, First Jamaica began a program for families called LOGOS. LOGOS is an intergenerational\n\t\t\t\t\tministry that has blessed congregations, communities, and families for over fifty\n\t\t\t\t\tyears. Through Bible study, a "), _c('span', {
    attrs: {
      "id": "z31-6"
    }
  }, [_vm._v("shared meal, worship, and recreation, the goals of\n\t\t\t\t\tLOGOS are to live out Acts 2:42: “They devoted themselves to the apostles’ teaching\n\t\t\t\t\tand to fellowship, to the breaking of bread and to prayer.” The LOGOS motto represented\n\t\t\t\t\twhat we wanted to live out among the families in our congregation and what we wanted\n\t\t\t\t\tto share with the community. That motto is this: “You are a child of God and I’ll\n\t\t\t\t\ttreat you that way.” But back in 2010, the real question was, “What will it mean\n\t\t\t\t\tto show people that they are children of God, and how will we treat them that way?\n\t\t\t\t\tWhere will we begin?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz31-7"
    }
  }, [_vm._v("\n\t\t\t\t\tWe started with getting ourselves in the right frame of mind regarding what intergenerational\n\t\t\t\t\tministry actually means. Even though we didn’t use the term "), _c('i', [_vm._v("intergenerational,")]), _vm._v(" we\n\t\t\t\t\tknew that this ministry would be more than just putting different ages of people\n\t\t\t\t\tin the same room to eat, learn, worship, and play together. We knew that it was about\n\t\t\t\t\tbuilding relationships and creating space for those relationships to be nurtured\n\t\t\t\t\tand to grow. It was about being at the table together with no other intention than\n\t\t\t\t\tto show this love of God that we had been called to live. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz31-8"
    }
  }, [_vm._v("\n\t\t\t\t\tIntergenerational ministry is about living this life together. Knowing names, knowing\n\t\t\t\t\tthese children of God in ways that we somehow miss on Sunday mornings during the\n\t\t\t\t\tworship hustle and bustle. It is about spending time learning things like where\n\t\t\t\t\tpeople are from, what they like (and don’t like), and what their dreams are. It is\n\t\t\t\t\tabout taking the time to get to know the people we sit next to each week, no matter\n\t\t\t\t\thow old or young they are. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz31-9"
    }
  }, [_vm._v("\n\t\t\t\t\tIt also means listening to each other. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz31-10"
    }
  }, [_vm._v("\n\t\t\t\t\tIt is amazing what you can learn about someone if you take the time to sit and really\n\t\t\t\t\tlisten to them as you share a meal. There is something very intimate about taking\n\t\t\t\t\tthe time to eat together. You never know what surprises might lie ahead. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz31-11"
    }
  }, [_vm._v("\n\t\t\t\t\tOne night at LOGOS, one of our adult leaders found out that Rosa was turning fifteen\n\t\t\t\t\tsoon and that Rosa had been dreaming of a quinceañera. (A quinceañera is a celebration\n\t\t\t\t\tof a fifteen-year-old girl’s birthday; its cultural roots are in Latin America.)\n\t\t\t\t\tRosa’s dream was beginning to fade because her mom didn’t have the resources to plan\n\t\t\t\t\tsuch an elaborate celebration. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz31-12"
    }
  }, [_vm._v("\n\t\t\t\t\tAt the end of the night, the adult leader came up with a brilliant idea. What if\n\t\t\t\t\twe, her LOGOS family, hosted her quinceañera? ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz32-6"
    }
  }, [_vm._v("\n\t\t\t\t\tSo with the help of most of the Friday night LOGOS youth, volunteers, and church\n\t\t\t\t\tstaff, we were able to host her dream Sweet 15. We used all the gifts of the LOGOS\n\t\t\t\t\tfamily to plan and lead the religious ceremony, to decorate, and to find sponsors\n\t\t\t\t\tfor the dresses and suits of the quinceañera court. LOGOS parents who were professional\n\t\t\t\t\thair stylists, make-up artists, and photographers donated their supplies and time\n\t\t\t\t\tfor the day. Another volunteer baked a three-tiered cake and decorated it with sparklers\n\t\t\t\t\tto light up the room. As a community, we were able to show Rosa that she was a child\n\t\t\t\t\tof God and that she was loved. We were living this motto out loud! ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz32-7"
    }
  }, [_vm._v("\n\t\t\t\t\tFriday nights became moments of grace, fun, and opportunities to love beyond our\n\t\t\t\t\twalls. They became a place where we could appreciate each other and experience God’s\n\t\t\t\t\tlove firsthand. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz32-8"
    }
  }, [_vm._v("\n\t\t\t\t\tFriday nights became a place where middle school kids could be encouraged to say\n\t\t\t\t\twhat they believed; Bible study became a place where they could express who God is\n\t\t\t\t\tto them; worship became a place that was about opening their hearts and mouths to\n\t\t\t\t\thonor God with their whole being. It was a place where a community of caring adults\n\t\t\t\t\tpoured into them—a place where no one was alone, and everyone was loved. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz32-9"
    }
  }, [_vm._v("\n\t\t\t\t\tFriday nights became alive in moments where young brown boys found a safe space in\n\t\t\t\t\ta world that often tells them they are not worthy. And a world that does not treat\n\t\t\t\t\tthem as the children of God they are. A world that does not always welcome them with\n\t\t\t\t\topen arms. Here, on Friday nights, these boys could lead, be led, be loved, serve,\n\t\t\t\t\tbe served, grow, and be who they are. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz32-11"
    }
  }, [_vm._v("\n\t\t\t\t\tFriday nights became moments where strangers became family, where children became\n\t\t\t\t\tstronger, and where adults learned to laugh again—where we messed up a few times\n\t\t\t\t\tbut came back every week to do it again because we believed that God was doing something\n\t\t\t\t\tfar greater than what we could see in the moment. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz32-12"
    }
  }, [_vm._v("\n\t\t\t\t\tGod gave this congregation—and me—a breath of fresh air, a reason to celebrate, and\n\t\t\t\t\ta chance to be living children of God treating each other with love and respect while\n\t\t\t\t\tpassing the potatoes and dancing in celebration. Twenty-year-old me might not approve\n\t\t\t\t\tof my thirty-year-old Friday nights. But right now, forty-year-old me is grateful\n\t\t\t\t\tto God for the blessing "), _c('span', {
    attrs: {
      "id": "z33-6"
    }
  }, [_vm._v("of a group of adults, children, and teens who made me a better\n\t\t\t\t\tperson and reminded me that I am a child of God and absolutely treated me that way.\n\t\t\t\t\t")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4",
    attrs: {
      "id": "pz33-7"
    }
  }, [_vm._v("\n\t\t\t\t\tThe Caring Church:"), _c('br'), _vm._v("Intergenerational Caring as a Foundation for Church Life ")]), _vm._v(" "), _c('p', {
    staticClass: "centerv",
    attrs: {
      "id": "pz33-8"
    }
  }, [_vm._v("\n\t\t\t\t\tJim Merhaut ")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotev",
    staticStyle: {
      "margin-bottom": "0.5em"
    },
    attrs: {
      "id": "pz33-9"
    }
  }, [_vm._v("\n\t\t\t\t\t\t“Then the "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Lord")]), _vm._v(" God said, ‘It is not good that the man should be alone . . .’” ")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotev",
    staticStyle: {
      "margin-bottom": "0.5em"
    },
    attrs: {
      "id": "pz33-10"
    }
  }, [_vm._v("\n\t\t\t\t\t\t—Genesis 2:18 ("), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("nrsv")]), _vm._v(") ")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotev",
    attrs: {
      "id": "pz33-11"
    }
  }, [_vm._v("\n\t\t\t\t\t\t“The best thing to hold onto in life is each other.” —Audrey Hepburn ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz33-12"
    }
  }, [_vm._v("\n\t\t\t\t\tResting quietly beneath the flurry of church administration hides an often-overlooked\n\t\t\t\t\tfoundation that is both soft and potent: the expressions of love that we call caring.\n\t\t\t\t\tLike God breathing life into dead clay, caring expressions of love across the generations\n\t\t\t\t\tare the animating principle of Christian congregations. Human beings are wired for\n\t\t\t\t\tcaring connections. Dr. Susan Johnson, clinical psychologist and researcher, often\n\t\t\t\t\tcomments that emotional connection among human beings is like oxygen. It is no exaggeration\n\t\t\t\t\tto say that warm, intimate, and continuous caring expressions of love are essential\n\t\t\t\t\tfor human life and for Christian community. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz33-13"
    }
  }, [_vm._v("\n\t\t\t\t\tJohnson tells a story of a Spanish bishop in 1760 who worked in an orphanage. He\n\t\t\t\t\trecorded in his journal that there were some children in the orphanage who were dying\n\t\t\t\t\tfrom loneliness. He could discern no other cause for their decline and death. Nearly\n\t\t\t\t\ttwo hundred years later, psychologist John Bowlby developed his theory of child\n\t\t\t\t\tattachment that confirms the essential importance of intergenerational caring for\n\t\t\t\t\thuman thriving."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a2",
      "id": "d2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "AfBiu"
    }
  }, [_vm._v("\n\t\t\t\t\tBowlby concluded, “the infant and young child should experience a warm, intimate,\n\t\t\t\t\tand continuous relationship with his mother (or permanent mother substitute) in\n\t\t\t\t\twhich both find satisfaction and enjoyment.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a3",
      "id": "d3"
    }
  }, [_vm._v("3")])]), _vm._v(" Notice the careful choice of words\n\t\t\t\t\tthat paint a picture of deep intergenerational connection: warm . . . intimate .\n\t\t\t\t\t. . continuous intergenerational relationship in which both generations find satisfaction\n\t\t\t\t\tand enjoyment. The benefits of human connection run in both directions up and down\n\t\t\t\t\tthe generations. This is not something that church leaders can accomplish with a\n\t\t\t\t\tpackaged program or resource. Building affectionate and continuous "), _c('span', {
    attrs: {
      "id": "z34-6"
    }
  }, [_vm._v("experiences of\n\t\t\t\t\thuman attachment requires changing the culture of congregations from peer-centered\n\t\t\t\t\tefficiency to places where relationships of all kinds reign supreme. In the caring\n\t\t\t\t\tchurch, getting things done is not as important as with whom and for whom we get\n\t\t\t\t\tthings done. ")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz34-7"
    }
  }, [_vm._v("\n\t\t\t\t\tHow many times in churches are young children and older adults excluded from activities\n\t\t\t\t\tor experiences because they might “slow things down”? When the center of our target\n\t\t\t\t\tbecomes accomplishment and not relationship, we cease to be Christian. The celebrated\n\t\t\t\t\tspirituality expert Michael Downey once said, “If you are what you do, when you don’t\n\t\t\t\t\t. . . then you’re not.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a4",
      "id": "d4"
    }
  }, [_vm._v("4")])]), _vm._v(" This doesn’t mean that doing is unimportant; it simply means\n\t\t\t\t\tthat the foundation for all Christian activity is caring relationships. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz34-8"
    }
  }, [_vm._v("\n\t\t\t\t\tBowlby’s career ended before he could test his child attachment theory on adults;\n\t\t\t\t\thowever, Phil Shaver and Cindy Hazan carried on his work at the University of Denver.\n\t\t\t\t\tThey tested attachment theory on adults in the 1980s and found that the emotional\n\t\t\t\t\tattachment needs that form the foundation of thriving for children do not go away\n\t\t\t\t\tas we grow up."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a5",
      "id": "d5"
    }
  }, [_vm._v("5")])]), _vm._v(" The myth of the detached, stoic, independent adult as the paradigm\n\t\t\t\t\tof adult maturity was shattered by Shaver and Hazan and has continued to disintegrate\n\t\t\t\t\tin study after study on adult thriving. Adults need caring expressions just as much\n\t\t\t\t\tas children do, and when they are experienced across the generations, they can be\n\t\t\t\t\teven more powerful for adult growth and development. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz34-9"
    }
  }, [_vm._v("\n\t\t\t\t\tOne church in Ohio set the following goal: to inspire and support friendships across\n\t\t\t\t\tthe generations. In the spirit of this goal, they have transformed their Vacation\n\t\t\t\t\tBible School into an intergenerational learning experience. Parents, grandparents,\n\t\t\t\t\tand other adults are enriched by the presence of children as they together enjoy\n\t\t\t\t\tlively and engaging activities around biblical themes. They have also developed a\n\t\t\t\t\tyouth ministry initiative to empower adults to reach out in friendship to teens\n\t\t\t\t\ton Sundays. This was accomplished by giving brief presentations to all adult groups\n\t\t\t\t\tin the church with information about the power of intergenerational friendship, and\n\t\t\t\t\tthen offering three simple strategies to adults for how they might connect with\n\t\t\t\t\tteens around Sunday worship: ")]), _vm._v(" "), _c('ol', {
    attrs: {
      "id": "lz34-10"
    }
  }, [_c('li', {
    attrs: {
      "id": "pz34-10"
    }
  }, [_vm._v("\n\t\t\t\t\t\tMake eye contact and smile. ")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "pz34-11"
    }
  }, [_vm._v("\n\t\t\t\t\t\tDeliberately seek out teens during the offering of peace. ")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "pz35-1"
    }
  }, [_vm._v("\n\t\t\t\t\t\tAsk teens about school, hobbies, work, friendships, prayer, etc. ")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz35-2"
    }
  }, [_vm._v("\n\t\t\t\t\tAt the end of the presentation, every adult was given a small card with the three\n\t\t\t\t\tstrategies and a pin that read, “We love our teens!” At the same time, children and\n\t\t\t\t\tteens were being encouraged to take on roles in the congregation that traditionally\n\t\t\t\t\twere reserved for adults. This church did not have to add new programs; it simply\n\t\t\t\t\thad to bring the generations together in programs that already existed. It’s so simple.\n\t\t\t\t\tIt’s so powerful. Imagine what your congregation can do by connecting the generations\n\t\t\t\t\twith expressions of care. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz35-3"
    }
  }, [_vm._v("\n\t\t\t\t\tOne of the best things we can do for both young and old is structure our churches\n\t\t\t\t\tin ways that facilitate continuous caring encounters across the generations so that\n\t\t\t\t\tall ages can be enfolded in the warmth of the full body of Christ. It is when the\n\t\t\t\t\tfull body is engaged with all its generational diversity that both the church and\n\t\t\t\t\tthe world will experience a congregation’s transforming power. ")]), _vm._v(" "), _c('h5', {
    staticClass: "h5",
    attrs: {
      "id": "A1_D"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "AZqt"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "bibliography",
    attrs: {
      "id": "A6Wc"
    }
  }, [_c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "AdE"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d1",
      "id": "a1"
    }
  }, [_vm._v("1")])]), _vm._v("See "), _c('a', {
    attrs: {
      "href": "http://www.faith5.org",
      "id": "AncZH",
      "target": "_blank"
    }
  }, [_vm._v("www.faith5.org")]), _vm._v(" for a fuller explanation of the FAITH5 process. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz35-5"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d2",
      "id": "a2"
    }
  }, [_vm._v("2")])]), _vm._v("Dr. Sue Johnson, "), _c('i', [_vm._v("Hold Me Tight: Seven Conversations for a Lifetime of Love")]), _vm._v(" (New\n\t\t\t\t\t\tYork: Little, Brown and Company, 2008), 16–27. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz35-6"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d3",
      "id": "a3"
    }
  }, [_vm._v("3")])]), _vm._v("John Bowlby, "), _c('i', [_vm._v("Maternal Care and Mental Health: A Report Prepared on Behalf of the\n\t\t\t\t\t\tWorld Health Organization as a Contribution to the United Nations Programme for the\n\t\t\t\t\t\tWelfare of Homeless Children")]), _vm._v(" (Geneva: World Health Organization, 1951), 13. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz35-7"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d4",
      "id": "a4"
    }
  }, [_vm._v("4")])]), _vm._v("Michael Downey, “Magnificent Distractions: Hurdles to Living Contemplatively,”\n\t\t\t\t\t\tpaper presented at the monthly meeting of the First Friday Club of Greater Youngstown\n\t\t\t\t\t\t(OH), January 5, 2017. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz35-8"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d5",
      "id": "a5"
    }
  }, [_vm._v("5")])]), _vm._v("Cindy Hazan and Philip Shaver, “Romantic Love Conceptualized as an Attachment Process,”\n\t\t\t\t\t\t"), _c('i', [_vm._v("Journal of Personality and Social Psychology")]), _vm._v(" 52, no. 3 (1987): 511–24. ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a60732a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter05.vue
// module id = 81
// module chunks = 0